<template>
	<section v-loading="loading1">
		<el-drawer placement="right" :visible="visible" size="85%" :show-close="false" :destroy-on-close="true"
			style="z-index:2000" :append-to-body="true">
			<div slot="title" style="display:flex;justify-content:space-between;align-items:center;">
				<div style="margin-left:auto;">
					<el-button type @click="close()">关闭</el-button>
					<el-button type="primary" @click="previewByStudent()">预览真实数据</el-button>
					<el-button type="primary" @click="toAddMission">发布任务</el-button>
				</div>
			</div>
			<div class="content" :style="'height:'+(innerHeight+80)+'px'">
				<el-container style="height: 100%;">
					<el-aside width="238px" class="aside-left">
						<div class="list-img" @click="previewImg(0)"
							:style="cur_index==-1?'border:1px solid #2EB6AA':''">
							<div class="out" style="cursor: pointer;text-align:center;">
								<div style="display:flex;justify-content: center;">
									<el-image :src="list.cover?list.cover:''" fit="contain" class="img"></el-image>
								</div>
							</div>
							<p class="text over">封面</p>
						</div>
						<div v-for="(item,index) in list.items" :key="index" @click="cur_index=index;openImg()"
							class="list-img" :style="item.checked?'border:1px solid #2EB6AA':''">
							<div class="out">
								<div v-if="item.tplBackGroundBOList&&item.tplBackGroundBOList.length>0"
									style="display:flex;justify-content: center;">
									<el-image
										:src="item.tplBackGroundBOList.find(e=>e.checked).path||item.tplBackGroundBOList[0].path"
										fit="contain" class="img"></el-image>
								</div>
							</div>
							<p class="text over">{{item.content_type?item.content_type.name:''}}</p>
							<div class="foot" v-if="isHadConfigPage(item)==1" @click.stop="setOneConfig(item,index,1)">
								<span style="color:#007AFF;cursor: pointer;">设置</span>
								<span style="color:#FF0000;margin-left:20px;">请完善设置</span>
							</div>
						</div>

						<div class="list-img" @click="previewImg(1)"
							:style="cur_index==-2?'border:1px solid #2EB6AA':''">
							<div class="out" style="cursor: pointer;text-align:center;">
								<div style="display:flex;justify-content: center;">
									<el-image :src="list.back_cover?list.back_cover:''" fit="contain" class="img">
									</el-image>
								</div>
							</div>
							<p class="text over">封底</p>
						</div>
					</el-aside>
					<el-main class="center" v-if="h5_pages">
						<iframe :src="h5_pages" name="myIframe0" ref="myIframe0" id="myIframe0" class="ifram1"
							frameborder="6"></iframe>
					</el-main>
				</el-container>
				<div class="right" v-if="big_item&&cur_index>=0">
					<el-select v-model="data_content" @change="changeData"
						v-if="big_item.component!='bless-c-school'&&big_item.content_type&&big_item.content_type.schema_str=='SCHOOL_BLESS'"
						placeholder="园长寄语" size="small" style="width:150px;margin:5 10;">
						<el-option v-for="(opt,o_ind) in data_list" :key="o_ind" :label="opt.name" :value="opt.content">
						</el-option>
					</el-select>

					<el-button type="text" @click="setCurObj(big_item)" v-if="big_item.content_type&&(
                            big_item.content_type.schema_str=='PHOTO'||
                            big_item.content_type.schema_str=='ONE_QUESSTION'||
                            big_item.content_type.schema_str=='QUESSTIONS'||
                            big_item.content_type.schema_str=='QUESTIONWEEK')">
						{{big_item.tplBackGroundBOList&&big_item.tplBackGroundBOList.length>1 ? '选择背景':'查看模板'}}
					</el-button>

					<el-button type="text" v-if="big_item.content_type&&(
                        big_item.content_type.schema_str.includes('PHOTO')||
                        big_item.content_type.schema_str=='HEALTHY'||
                        big_item.content_type.schema_str=='ONE_QUESSTION'||
                        big_item.content_type.schema_str=='QUESSTIONS'||
                        big_item.content_type.schema_str=='QUESTIONWEEK')" @click="setOneConfig(big_item,cur_index)">
						设置规则</el-button>

					<el-button type="text"
						v-if="(is_edit==1)&&big_item.content_type&&big_item.content_type.schema_str=='TEACHER_INTRO'"
						@click="openUser()">选择老师</el-button>
				</div>
			</div>
		</el-drawer>

		<!-- 设置模板 -->
		<content-tpl-list ref="contentTplRef" @closeTpl="closeTpl"></content-tpl-list>

		<!-- 设置规则 -->
		<set-config ref="setConfigRef" @setCurConfig="setCurConfig"></set-config>

		<!-- 预览 -->
		<preview-tpl ref="previewRef" @closeTileVisible="closeTileVisible"></preview-tpl>

		<!-- 编辑书 -->
		<edit-book ref="editBookRef"></edit-book>
	</section>
</template>
<script>
	import { theme, book_preview, book_index, upload, bless } from "@/api/book";
	import contentTplList from "@/components/book/contentTplList";
	import setConfig from "@/components/book/setConfig";
	import previewTpl from "@/components/book/previewTpl";
	import editBook from "@/components/book/editBook";
	import { mapState } from "vuex";

	export default {
		//is_edit=1编辑,0仅查看
		props: ["is_edit"],
		data() {
			return {
				visible: false,
				dialogFormVisible: false,
				content_options: [],
				itemObj: "",
				contentValue: "",
				optionsValue: "",
				list: {
					school_id: "",
					price: null,
					name: "",
					ispublic: "", // true为公用，false为私用
					status: "", //0=下架，1=上架，默认上架传1
					thumbnail: "",
					cover: "",
					back_group: "",
					items: []
				},
				theme_id: null, //主题id

				cur_index: -1, //当前操作的索引值

				loading1: false,
				big_item: null,

				data_list: [], //素材列表:
				data_content: "",
				h5_pages: "",
				base_url: process.env.book_preview_url,
				mission_set: [], //保存发布任务的设置规则

				class_id: null,
				mission_id: null,

				is_can_edit: false,
				select_number: 4
			};
		},

		components: { contentTplList, setConfig, previewTpl, editBook },

		computed: {
			...mapState("user", ["innerHeight"]),
			...mapState("book", ["bookSize"])
		},

		methods: {
			// 选择人员
			openUser() {
				let user_number = 4;
				if (
					this.big_item &&
					this.big_item.schema &&
					this.big_item.schema.NUMBER
				) {
					user_number = this.big_item.schema.NUMBER;
				}
				this.$emit("openUser", user_number, []);
			},
			getTeacherList(items) {
				this.visible = true;
				let data1 = items.map(r => {
					return {
						name: r.name,
						brief: r.brief,
						avatar: r.avatar_url
					};
				});
				let param = {
					//管理员修改园长寄语配置
					id: this.theme_id,
					item_index: this.cur_index,
					theme_item: {
						theme_tpl_id: this.big_item.tpl_id
							? this.big_item.tpl_id
							: null,
						content_type_id: this.big_item.content_type
							? this.big_item.content_type.id
							: null,
						tpl_back_group_id: this.big_item.tplBackGroundBOList.map(
							r => r.id
						),
						config: this.big_item.config ? this.big_item.config : {},
						data: data1
					}
				};
				this.loading1 = true;
				theme.updataItem(param).then(res => {
					this.loading1 = false;
					if (res.code == 0) {
						this.reGeg();
						this.$message({ message: "设置成功！", type: "success" });
					}
				});
			},

			//判断当前页是否需要配置
			isHadConfigPage(data) {
				let type =
					data.content_type && data.content_type.schema_str
						? data.content_type.schema_str.includes("PHOTO")
							? "PHOTO"
							: data.content_type.schema_str
						: null;
				let config = data.config ? data.config : {};
				let ret_type = 0; // 0无需配置，1未配置，2已配置
				if (!type) {
					return 0; //无需配置
				}
				switch (type) {
					case "PHOTO":
						if (
							config &&
							config.datasource &&
							config.datasource.length > 0
						) {
							ret_type = 2;
						} else {
							ret_type = 1;
						}
						break;
					case "ONE_QUESSTION":
					case "QUESSTIONS":
					case "QUESTIONWEEK":
						if (config && config.questionnaire_id) {
							ret_type = 2;
						} else {
							ret_type = 1;
						}
						break;
					case "HEALTHY":
						if (
							config &&
							config.topic_id &&
							config.topic_id.length > 0
						) {
							ret_type = 2;
						} else {
							ret_type = 1;
						}
						break;
					case "SCHOOL_BLESS":
						if (data.component != 'bless-c-school') {
							if (data.data && data.data.length > 0) {
								ret_type = 2;
							} else {
								ret_type = 1;
							}
						}
						break;
					default:
						ret_type = 0;
						break;
				}
				return ret_type;
			},

			getNeedConfigNum() {
				//统计需要配置的页数
				let num = 0;
				this.list.items.forEach(r => {
					let type =
						r.content_type && r.content_type.schema_str
							? r.content_type.schema_str.includes("PHOTO")
								? "PHOTO"
								: r.content_type.schema_str
							: null;
					if (type) {
						switch (type) {
							case "PHOTO":
								num += 1;
								break;
							case "ONE_QUESSTION":
							case "QUESSTIONS":
							case "QUESTIONWEEK":
								num += 1;
								break;
							case "HEALTHY":
								num += 1;
								break;
							case "SCHOOL_BLESS":
								if (r.component != 'bless-c-school') {
									num += 1;
								}
								break;
							default:
								break;
						}
					}
				});
				return num;
			},

			previewByStudent() {
				let items = [];
				this.$parent.previewByStudent();
			},
			openPreviewStudent(data) {
				//打开预览真实数据
				this.visible = true;
				let items = this.getTearmByGroup(data, 1);
				items.unshift({
					tpl: "cover-a",
					key: -1,
					back_group: this.list.cover,
					data: [],
					page_index: -1,
					config: null,
					data_schema: []
				});
				items.push({
					tpl: "cover-a",
					key: -2,
					back_group: this.list.back_cover,
					data: [],
					page_index: -2,
					config: null,
					data_schema: []
				});
				let that = this;
				setTimeout(() => {
					that.$nextTick(_ => {
						that.$refs.previewRef.openTileVisible(items, "see");
					});
				}, 1000);
			},

			close() {
				this.visible = false;
				this.theme_id = null;
				this.class_id = null;
				this.mission_is = null;
			},

			previewImg(val) {
				this.cur_index = val == 0 ? -1 : -2; //-1封面 -2封底
				this.h5_pages = `${this.base_url}/see?width=${this.bookSize.width}&height=${this.bookSize.height}`;
				if (this.list.items && this.list.items.length > 0) {
					this.list.items.forEach((r, i) => {
						r.checked = false;
					});
				}
				let item = {
					tpl: "cover-a",
					key: 0,
					back_group: val == 0 ? this.list.cover : this.list.back_cover,
					list: "",
					page_index: 0,
					config: null,
					data_schema: []
				};

				let that = this;
				if (document.getElementById("myIframe0")) {
					setTimeout(() => {
						document
							.getElementById("myIframe0")
							.contentWindow.postMessage([item], that.h5_pages);
					}, 1000);
				} else {
					let timer = setInterval(() => {
						if (document.getElementById("myIframe0")) {
							document.getElementById("myIframe0").onload = _ => {
								document
									.getElementById("myIframe0")
									.contentWindow.postMessage(
										[item],
										that.h5_pages
									);
							};
							clearInterval(timer);
						}
					}, 10);
				}
			},

			goPreview(val) {
				//2预览整本（抽屉），1预览某一页（抽屉），0预览某一页（中间）
				if (!this.theme_id) {
					this.$message({ message: "暂无数据！", type: "success" });
					return;
				}
				let data1 = {
					book_id: this.list.preview_book_id,
					page_index: val == 2 ? null : this.cur_index,
					is_edit: this.is_edit == 1 ? 1 : 0,
					is_where: 2 //1大后台2.学校管理员3.普通老师4.家长 0仅查看(游客)
				};

				this.h5_pages =
					`${this.base_url}/book/` +
					data1.book_id +
					"?is_edit=" +
					data1.is_edit +
					"&page_index=" +
					data1.page_index +
					"&is_where=" +
					data1.is_where +
					"&width=" +
					this.bookSize.width +
					"&height=" +
					this.bookSize.height;

				if (val != 0) {
					data1.is_edit = 0;
					this.$refs.previewRef.openTileVisible(data1);
				} else {
					this.h5_pages = `${this.base_url}/see?width=${this.bookSize.width}&height=${this.bookSize.height}`;

					let items = this.getTearmByGroup([this.big_item]);
					let that = this;

					if (document.getElementById("myIframe0")) {
						document
							.getElementById("myIframe0")
							.contentWindow.postMessage(items, that.h5_pages);
					} else {
						let timer = setInterval(() => {
							if (document.getElementById("myIframe0")) {
								document.getElementById("myIframe0").onload = _ => {
									document
										.getElementById("myIframe0")
										.contentWindow.postMessage(
											items,
											that.h5_pages
										);
								};
								clearInterval(timer);
							}
						}, 10);
					}
				}
			},

			getTearmByGroup(data, val) {
				let books = [];
				if (!(data && data.length > 0)) {
					return [];
				}
				data.forEach((item, index) => {
					let tpl_list = item.component.split(",");
					if (tpl_list && tpl_list.length > 0) {
						let arr = {
							tpl: tpl_list[0],
							key: index,
							back_group:
								item.tplBackGroundBOList &&
									item.tplBackGroundBOList.find(e => e.checked)
									? item.tplBackGroundBOList.find(e => e.checked)
										.path
									: item.backgroup,
							list: item.data ? item.data : [],
							page_index: item.page_index || 0,
							config: item.config,
							data_schema:
								val == 1
									? item.data_schema
									: item.content_type
										? [item.content_type.schema_str]
										: []
						};
						if (arr.data_schema.includes("ONE_QUESSTION")) {
							let data1 =
								item.data && item.data.length > 0 && item.data[0]
									? item.data[0]
									: { sections: [] };
							tpl_list.forEach((a, a_index) => {
								let sub = JSON.parse(JSON.stringify(arr));
								sub.tpl = a;
								sub.key = index + "-" + a_index;

								let jk =
									data1.sections &&
										data1.sections.find(u => u.title == "健康")
										? data1.sections.find(
											u => u.title == "健康"
										)
										: null;
								let sh =
									data1.sections &&
										data1.sections.find(u => u.title == "社会")
										? data1.sections.find(
											u => u.title == "社会"
										)
										: null;
								let yy =
									data1.sections &&
										data1.sections.find(u => u.title == "语言")
										? data1.sections.find(
											u => u.title == "语言"
										)
										: null;

								let kx =
									data1.sections &&
										data1.sections.find(u => u.title == "科学")
										? data1.sections.find(
											u => u.title == "科学"
										)
										: null;
								let ys =
									data1.sections &&
										data1.sections.find(u => u.title == "艺术")
										? data1.sections.find(
											u => u.title == "艺术"
										)
										: null;
								let rzfz = data1.sections && data1.sections.find(u => u.title == '认知发展') ? data1.sections.find(u => u.title == '认知发展') : null
								let shxfz = data1.sections && data1.sections.find(u => u.title == '社会性发展') ? data1.sections.find(u => u.title == '社会性发展') : null
								switch (a) {  //grade3小班，grade4中班
									case 'term-grade3-section-1':
									case 'term-grade4-section-1':
									case 'term-b1':
									case 'term-b4':
									case 'term-b7':
									case 'term-c1':
									case 'term-c4':
									case 'term-c7':
									case 'term-d1':
									case 'term-d4':
									case 'term-d7':

									case 'term-d1-1':
									case 'term-d4-1':
									case 'term-d7-1':
										sub.list = [jk]
										break;
									case 'term-grade3-section-2-3':
									case 'term-c2':
									case 'term-d2':
									case 'term-d5':

									case 'term-d2-1':
									case 'term-d5-1':
										sub.list = [sh, yy]
										break;
									case 'term-d8':
									case 'term-d8-1':
										sub.list = [sh, ys]
										break;
									case 'term-d9':
									case 'term-d9-1':
										sub.list = [kx, yy]
										break;
									case 'term-grade3-section-4-5':
									case 'term-c3':
									case 'term-d3':
									case 'term-d6':

									case 'term-d3-1':
									case 'term-d6-1':
										sub.list = [kx, ys]
										break;

									case 'term-grade4-section-2-3':
									case 'term-c5':
									case 'term-c8':
										sub.list = [yy, ys]
										break;
									case 'term-grade4-section-4-5':
										sub.list = [sh, kx]
										break;
									case 'term-c9':
									case 'term-c6':
										sub.list = [kx, sh]
										break;
									case 'term-a':
										sub.list = data1
										break
									case 'term-b2':
									case 'term-b5':
									case 'term-b8':
										sub.list = [rzfz]
										break;
									case 'term-b3':
									case 'term-b6':
									case 'term-b9':
										sub.list = [shxfz]
										break;
								}

								books.push(sub);
							});
						} else if (arr.data_schema.includes("QUESTIONWEEK")) {
							let data2 =
								item.data &&
									item.data.length > 0 &&
									item.data.filter(e => e) &&
									item.data[0].data
									? item.data[0].data
									: [];
							tpl_list.forEach((a, a_index) => {
								let sub = JSON.parse(JSON.stringify(arr));
								sub.tpl = a;
								sub.key = index + "-" + a_index;
								switch (a) {
									case 'question-b4':
									case "question-a":
										sub.list =
											data2 && data2.length > 0
												? [
													{
														data: [
															data2[0],
															data2.length > 1
																? data2[1]
																: []
														]
													}
												]
												: [];
										books.push(sub);
										break;
									case 'question-b5':
									case "question-a-1":
										sub.list =
											data2 && data2.length > 2
												? [
													{
														data: [
															data2[2],
															data2.length > 3
																? data2[3]
																: []
														]
													}
												]
												: [];
										books.push(sub);
										break;
									case 'question-b6':
									case "question-a-2":
										sub.list =
											data2 && data2.length > 4
												? [
													{
														data: [
															data2[4],
															data2.length > 5
																? data2[5]
																: []
														]
													}
												]
												: [];
										books.push(sub);
										break;
									case 'question-c1':
									case 'question-c2':
									case 'question-c3':
									case 'question-c1-1':
									case 'question-c2-1':
									case 'question-c3-1':
										if (data2 && data2.length > 0) {
											data2.forEach((t, t_index) => {
												let t_arr = JSON.parse(JSON.stringify(sub))
												t_arr.key = t_index
												t_arr.list = [{ data: [t] }]
												books.push(t_arr)
											})
										} else {
											sub.list = []
											books.push(sub)
										}
										break;
								}
							});
						} else if ((tpl_list.includes('question-b1') || tpl_list.includes('question-d1')) && arr.data_schema.includes('QUESSTIONS')) {   //穗花每月评价
							let data2 = item.data && item.data.length > 0 && item.data.filter(e => e) && item.data[0].sections && item.data[0].sections.length > 0 ? item.data[0].sections : []
							let list_total = []
							tpl_list.forEach((a, a_index) => {
								let sub = JSON.parse(JSON.stringify(arr));
								sub.tpl = a;
								sub.key = index + "-" + a_index;

								let list_1 = []

								data2.forEach((x, w) => {
									let atts = { school: [], parent: [] }
									let ret0 = x.list.findIndex(e => e.name == 'school')
									if (ret0 != -1) {
										x.list[ret0].list.forEach(v => {
											if (v.list && v.list.length > 0) {
												atts.school.push({ title: v.title, index: v.index, list: v.list })
											}
										})
									}

									let ret1 = x.list.findIndex(e => e.name == 'parent')
									if (ret1 != -1) {
										x.list[ret1].list.forEach(v => {
											if (v.list && v.list.length > 0) {
												atts.parent.push({ title: v.title, index: v.index, list: v.list })
											}
										})
									}

									list_1.push({ title: '', sect_title: x.title, atts: atts, sec_index: w })
									list_1.forEach(z => {
										if (z.atts && z.atts.school) {
											z.atts.school.forEach(n => {
												let ret2 = list_total.findIndex(a => a.index == z.sec_index + '-' + n.index)
												if (ret2 != -1) {
													list_total[ret2].title = n.title
													list_total[ret2].school_list = n.list
												} else {
													list_total.push({
														index: n.index,
														title: n.title,
														sect_title: z.sect_title,
														school_list: n.list,
														parent_list: [],
													})
												}
											})
										}

										if (z.atts && z.atts.parent) {
											z.atts.parent.forEach(n => {
												let ret2 = list_total.findIndex(a => a.index == n.index)
												if (ret2 != -1) {
													list_total[ret2].title = n.title
													list_total[ret2].parent_list = n.list
												} else {
													list_total.push({
														index: z.sec_index + '-' + n.index,
														title: n.title,
														sect_title: z.sect_title,
														parent_list: n.list,
														school_list: [],
													})
												}
											})
										}
									})
								})

								switch (a) {
									case 'question-b1':
									case 'question-b2':
									case 'question-b3':
									case 'question-d1':
										sub.list = list_total
										books.push(sub)
										break
									case 'question-d2':
									case 'question-d3':
										let data3 = item.data && item.data.length > 0 && item.data.filter(e => e) && item.data[0].commits && item.data[0].commits.length > 0 ? item.data[0].commits : []
										if (data3 && data3.length > 0) {
											let u_list = []
											data3.forEach((u, u_index) => {
												u.week = u.week || 4
												let u_ret = u_list.findIndex(o => o.week == u.week)
												if (u_ret == -1) {
													u_list.push({ week: u.week, commits: [{ user_type: u.user_type, content: u.content }] })
												} else {
													u_list[u_ret].commits.push({ user_type: u.user_type, content: u.content })
												}
											})
											sub.list = u_list
										}
										books.push(sub)
										break;
								}
							})
						} else {
							books.push(arr);
						}
					}
				});
				return books;
			},

			toAddMission() {
				let mission_set1 = [];
				let num = this.getNeedConfigNum();
				let had_set_num = 0;
				this.list.items.forEach((r, i) => {
					if (this.isHadConfigPage(r) == 2) {
						had_set_num += 1;
					}
					mission_set1.push({
						index: i,
						config: r.config
							? r.config
							: { permission_type: "TEACHER" },
						tpl_back_group: r.tplBackGroundBOList
							.filter(z => z.id && z.checked)
							.map(e => e.id)[0],
						data: r.data
					});
				});
				if (had_set_num == num) {
					this.visible = false;
					this.$parent.backIndex(mission_set1);
				} else {
					this.$message({ message: "请完善配置", type: "erer" });
				}
			},

			closeTileVisible() {
				this.visible = true;
			},
			setCurConfig(data) {
				if (!this.big_item) {
					return;
				}
				let one = this.list.items[this.cur_index];
				one.config = data ? data : {};
				this.list.items.splice(this.cur_index, 1, one);
				this.$nextTick();
				this.$refs.setConfigRef.close();
			},
			// 打开设置规则
			setOneConfig(item, index, val) {
				this.cur_index = index;
				if (val == 1) {
					this.openImg();
				}
				let is_disable = false;
				this.$refs.setConfigRef.openVisible(item, is_disable);
			},
			openImg() {
				this.cur_index = this.cur_index ? this.cur_index : 0;
				this.big_item = this.list.items[this.cur_index];
				if (this.list.items && this.list.items.length > 0) {
					this.list.items.forEach((r, i) => {
						r.checked = i == this.cur_index ? true : false;
					});
				}
				this.list.items.splice(
					this.cur_index,
					1,
					this.list.items[this.cur_index]
				);
				this.data_content = null;
				this.data_list = [];

				this.getDataList();
				this.goPreview(0);
			},

			//更换或查看背景
			setCurObj(data) {
				let data1 = data;
				let type =
					data1.tplBackGroundBOList &&
						data1.tplBackGroundBOList.length > 1
						? 0
						: 2;
				this.$refs.contentTplRef.setHadCur(data1, this.cur_index, type);
			},

			closeTpl(data) {
				//选择背景
				this.list.items[this.cur_index].tplBackGroundBOList =
					data.tpl_back_group_list;
				this.list.items.splice(
					this.cur_index,
					1,
					this.list.items[this.cur_index]
				);
				this.big_item = this.list.items[this.cur_index];
				this.goPreview(0);
				this.$refs.contentTplRef.close();
			},

			// 获取素材列表
			getDataList() {
				let type =
					this.big_item.content_type &&
						this.big_item.content_type.schema_str
						? this.big_item.content_type.schema_str
						: null;
				if (type != "SCHOOL_BLESS") {
					return;
				}
				this.data_list = [];
				this.data_content = null;
				let param = {
					currentPage: 1,
					pageSize: 999
				};
				bless.findBless(param).then(res => {
					if (res.data) {
						this.data_list = res.data.list;
					}
				});
			},

			changeData() {
				//发任务配置园长寄语
				this.list.items[this.cur_index].data = [
					{ data: { content: this.data_content } }
				];
				this.list.items.splice(
					this.cur_index,
					1,
					this.list.items[this.cur_index]
				);
				this.big_item = this.list.items[this.cur_index];
				this.goPreview(0);
			},

			getDetail() {
				this.loading1 = true;
				let promise = theme.findOne({ id: this.theme_id });
				return promise.then(res => {
					this.loading1 = false;
					if (res.data) {
						this.list = res.data;
						let bookSize = {
							width: this.list.width || 11.26,
							height: this.list.height || 8.5
						}; //画册尺寸：横版11.26*8.5 ，竖版8.5*11.26
						this.$store.commit("book/getBookSize", bookSize);

						if (this.list.items && this.list.items.length > 0) {
							this.list.items.forEach(r => {
								if (
									r.tplBackGroundBOList &&
									r.tplBackGroundBOList.length > 0
								) {
									r.tplBackGroundBOList.forEach((r, i) => {
										r.checked = i == 0 ? true : false;
									});
								}
								if (
									r.content_type &&
									r.content_type.schema &&
									r.content_type.schema.length > 0 &&
									r.content_type.schema[0] != null
								) {
									r.content_type.schema_str = r.content_type.schema.join(
										"-"
									);
								}
							});

							if (this.cur_index == -1) {
								this.previewImg(0);
							} else {
								if (this.list.items[this.cur_index]) {
									this.openImg();
								}
							}
						}
					}
					return res;
				});
			},

			open(id) {
           
				this.h5_pages = null;
				if (!id) {
					return;
				}

				this.theme_id = id;
				this.cur_index = -1;
				this.visible = true;
				this.list.items = [];
				this.getDetail();
			},

			reGeg() {
				window.open(
					document.getElementById("myIframe0").src,
					"myIframe0",
					""
				); //强制刷新iframe ，用document会产生跨域问题
			}
		},
		mounted() {
			this.$store.commit("book/updateIsAll", false); //标记是否整体编辑
			window.addEventListener(
				"message",
				e => {
					console.log("===22222=4=")
					if (e && e.data && e.data.book_id) {
						// 根据条件判断当前是否去操作，否则产生重复操作问题
						if (this.theme_id) {
							if (this.$refs.editBookRef) {
								this.$refs.editBookRef.openEditVisible(e.data);
							}
						}
					}
				},
				true
			);
		}
	};
</script>
<style lang="scss" scoped>
	.content {
		display: flex;
		flex-wrap: nowrap;
		height: 100%;
		width: 100%;
		position: relative;
	}

	.aside-left {
		display: flex;
		flex-direction: column;
		background-color: #ffffff;
		padding-top: 10px;
		height: 100%;
		padding-bottom: 50px;
		.list-img {
			width: 180px;
			font-size: 14px;
			line-height: 1.5;
			margin: 0 auto;
			margin-bottom: 20px;
			position: relative;
			.out {
				width: 178px;
				height: 178px;
				border: 1px solid #f2f2f2f2;

				display: table-cell;
				vertical-align: middle;
				.el-image /deep/ .el-image__inner {
					height: 178px;
				}
				.img {
					width: auto;
					height: auto;
					max-width: 100%;
					max-height: 100%;
				}
				.checked {
					border: 1px solid #2eb6aa;
				}
			}
			.text {
				color: rgba(102, 102, 102, 1);
				font-size: 14px;
				line-height: 2;
				padding-top: 10px;
			}
			.foot {
				display: flex;
				color: rgba(102, 102, 102, 1);
				font-size: 14px;
			}
			.over {
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				word-break: break-all;
				flex-grow: 1;
			}
			.add {
				position: absolute;
				bottom: -16px;
				font-size: 35px;
				cursor: pointer;
				color: #2eb6aa;
				left: 40%;
				right: 40%;
				margin: auto;
			}
		}
	}

	.right {
		background: #ffffff;
		line-height: 2;
		font-size: 14px;
		display: flex;
		flex-direction: column;
		margin-left: auto;
		height: 100%;
		.el-button {
			margin-left: 0px;
			width: 150px;
		}
	}
	.center {
		text-align: center;
		background-color: #f2f2f2;
		padding: 0 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		.el-image {
			margin-bottom: 20px;
		}

		.ifram1 {
			width: 100%;
			height: 100%;
			align-items: center;
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/book/editThemeMission.vue